import { render, staticRenderFns } from "./level-card.vue?vue&type=template&id=576422a0&scoped=true&"
import script from "./level-card.vue?vue&type=script&lang=ts&"
export * from "./level-card.vue?vue&type=script&lang=ts&"
import style0 from "./level-card.vue?vue&type=style&index=0&id=576422a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576422a0",
  null
  
)

export default component.exports